import { memo } from 'react';
import FileAttachmentItem from './FileAttachmentItem';
import type { AttachedFile } from '@/types/files';

interface AttachedFilesListProps {
  files: AttachedFile[];
  onRemove: (id: string) => void;
  onRetry?: (id: string) => void;
}

function AttachedFilesList({ files, onRemove, onRetry }: AttachedFilesListProps) {
  if (files.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2 px-4 pb-2">
      {files.map((file) => (
        <FileAttachmentItem
          key={file.id}
          file={file}
          onRemove={onRemove}
          onRetry={onRetry}
        />
      ))}
    </div>
  );
}

export default memo(AttachedFilesList);
